import { postRequest, getRequest } from '.';

export const getStations = async () => getRequest('stations');
export const validateUser = async (email: string, stationId: string) =>
  postRequest('authenticate-user', { email, station_id: stationId });

export interface CheckUserResponse {
  exists: boolean;
  passwordless: boolean;
  enabled: boolean;
  userId?: string;
  username?: string;
  email?: string;
}

export const checkUser = async (userId: string): Promise<CheckUserResponse> => {
  const response = await postRequest<CheckUserResponse>('auth/check-user', { userId });

  if (!response) {
    throw new Error('Failed to check user');
  }

  return response;
};
